import { type CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type EsIndex } from '../types';

export interface BettingInsightsSortingConfig<TIndex extends EsIndex> {
	canSort: (
		this: BettingInsightsSorting<TIndex>,
		data: {
			refinements: CurrentRefinementsConnectorParamsItem[];
		},
	) => boolean;
}

export class BettingInsightsSorting<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsSortingConfig<TIndex>
{
	canSort: (
		this: BettingInsightsSorting<TIndex>,
		data: {
			refinements: CurrentRefinementsConnectorParamsItem[];
		},
	) => boolean;

	constructor({
		canSort,
		...requestContext
	}: BettingInsightsSortingConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.canSort = canSort?.bind(this);
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsSortingConfig<TIndex>,
	) {
		return new this<TIndex>({
			...requestContext,
			...config,
		});
	}
}
